import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  constructor() {}

  getScrollPosition(): Observable<Event> {
    return fromEvent(window, 'scroll');
  }
}